document.addEventListener("DOMContentLoaded", () => {

    const faqItems = document.querySelectorAll(".question-block");

    faqItems.forEach(item => {

        const top = item.querySelector(".faq-top");

        top.addEventListener("click", () => {

            const isActive = item.classList.contains("active");

            faqItems.forEach(faq => {
                faq.classList.remove("active");
            });

            if (!isActive) {
                item.classList.add("active");
            }

        });

    });

});